


export const SEOSection = () => (
  <div className="space-y-3">
    <h3 className="text-xs font-semibold uppercase text-muted-foreground">SEO</h3>
    <div className="space-y-4">
      <div>
        <label className="text-xs font-medium mb-1 block">Meta Title</label>
        <input type="text" className="w-full border bg-background rounded px-3 py-1.5 text-sm" />
      </div>
      <div>
        <label className="text-xs font-medium mb-1 block">Meta Description</label>
        <textarea className="w-full border bg-background rounded px-3 py-1.5 text-sm min-h-[80px]" />
      </div>
    </div>
  </div>
);
